import { render, staticRenderFns } from "./AssignSpg.vue?vue&type=template&id=418a03a6&scoped=true&"
import script from "./AssignSpg.vue?vue&type=script&lang=js&"
export * from "./AssignSpg.vue?vue&type=script&lang=js&"
import style0 from "./AssignSpg.vue?vue&type=style&index=0&id=418a03a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a03a6",
  null
  
)

export default component.exports